"use client";

import { useMemo } from "react";
import { TaskTypes } from "@/config/task-types";
import { getAirdropArgumentValue } from "@/lib/challenges";
import { IAirdropTaskRender } from "@/types/task-renderer.types";
import { Button } from "@heroui/react";
import { QuestTaskButton } from "../QuestTaskButton";

export const DefaultTaskRenderer = ({
  task,
  campaign,
  completeTaskMutation,
}: IAirdropTaskRender) => {
  const taskConfig = useMemo(() => {
    const campaignTask = campaign?.tasks?.find((t) => t.id === task.taskGuid);
    if (!campaignTask) return null;
    const parsedTierInfo = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "tierInfo") || "{}"
    );
    const externalLink = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "externalLink") || "{}"
    ) as {
      link: string;
      text: string;
    };
    const tokenInfo = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "tokenInfo") || "{}"
    ) as {
      image: string;
      symbol: string;
    };
    // Default tierInfo using campaign metadata
    const defaultTierInfo = {
      type: "usd" as const,
      tokenInfo: tokenInfo,
    };
    return {
      type: campaignTask.type,
      tierInfo:
        Object.keys(parsedTierInfo).length > 0
          ? parsedTierInfo
          : defaultTierInfo,
      tiers: JSON.parse(
        getAirdropArgumentValue(campaignTask.arguments, "pointsTiers") || "{}"
      ),
      externalLink,
    };
  }, [campaign, task]);

  const buttonName = useMemo(() => {
    if (task.taskName === TaskTypes.LIKE_POST) {
      return "Like Post";
    } else if (task.taskName === TaskTypes.SHARE_PROGRESS) {
      return "Share Progress";
    } else if (task.taskName === TaskTypes.FOLLOW_TWITTER) {
      return "Follow";
    } else if (task.taskName === TaskTypes.RETWEET) {
      return "Retweet";
    } else if (task.taskName === TaskTypes.DISCORD_ROLE) {
      return "Claim Role";
    }
    return "Claim";
  }, [task.taskName]);

  return (
    <>
      <div className="flex flex-row items-center gap-2">
        {taskConfig?.externalLink && taskConfig.externalLink?.link && (
          <a href={taskConfig.externalLink.link} target="_blank" rel="noopener noreferrer">
            <Button
              variant="bordered"
              className="rounded-lg border-gray-600/30 text-green-500 hover:bg-green-500/5 transition-all duration-200 font-medium"
            >
              {taskConfig.externalLink.text}
            </Button>
          </a>
        )}
        <QuestTaskButton
          buttonText={buttonName}
          taskMutation={completeTaskMutation}
          className="mt-0"
          task={task}
          onClick={() => {
            completeTaskMutation.mutateAsync({
              taskGuid: task.taskGuid,
              taskName: task.taskName,
              campaignId: campaign.id,
              extraArguments: task.extraArguments,
              groupId: campaign.campaignGroup,
            });
          }}
        />
      </div>
    </>
  );
};
